import { suppliesShippingStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

/**
 * The supplies shipping rule tree, created on first read so the editor always
 * has a flow to save into.
 */
export const getSuppliesShippingFlow = {
  name: "getSuppliesShippingFlow" as const,
  input: z.object({}),
  output: z.object({
    flowId: z.string(),
    name: z.string(),
    steps: suppliesShippingStepArraySchema,
    /** Null until the tree has been published; PR-2 evaluation reads the latest. */
    publishedAt: z.date().nullable(),
  }),
};
